import React from 'react';
import { Box, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@material-ui/core';
import { STRATEGY_EXAMPLES, STRATEGY_GLOSSARY } from '../../../constants/promotionStrategyExamples';

const SavingCell = ({ saving }) => {
    if (!saving || saving === '—') {
        return <Typography variant="body2">—</Typography>;
    }
    const text = typeof saving === 'string' ? saving : saving.text;
    const highlight = typeof saving === 'object' && saving.highlight;
    return (
        <Box
            component="span"
            style={{
                display: 'inline-block',
                padding: '2px 8px',
                borderRadius: 12,
                fontSize: 12,
                fontWeight: 600,
                background: highlight ? '#E8F5E9' : '#F0F0F0',
                color: highlight ? '#2E7D32' : '#666',
            }}
        >
            {text}
        </Box>
    );
};

const ExampleTable = ({ scenario }) => (
    <Box mb={2.5}>
        <Typography variant="body2" style={{ fontWeight: 600, marginBottom: 8 }}>
            {scenario.title}
        </Typography>
        <Box style={{ overflowX: 'auto', border: '1px solid #E8E8E8', borderRadius: 8 }}>
            <Table size="small">
                <TableHead>
                    <TableRow style={{ background: '#FAFAFA' }}>
                        <TableCell style={{ fontWeight: 600, width: 72 }} />
                        <TableCell style={{ fontWeight: 600 }}>Precio de venta</TableCell>
                        <TableCell style={{ fontWeight: 600 }}>Precio tachado</TableCell>
                        <TableCell style={{ fontWeight: 600 }}>Ahorro en tienda</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {scenario.rows.map((row) => (
                        <TableRow key={`${scenario.title}-${row.label}`}>
                            <TableCell style={{ fontWeight: 500, color: '#666' }}>{row.label}</TableCell>
                            <TableCell>{row.price}</TableCell>
                            <TableCell>{row.compareAt}</TableCell>
                            <TableCell>
                                <SavingCell saving={row.saving} />
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </Box>
    </Box>
);

const PromotionStrategyExample = ({ strategyId }) => {
    const example = STRATEGY_EXAMPLES[strategyId];
    if (!example) return null;

    return (
        <Box
            mt={2}
            p={2}
            style={{
                background: '#F9FAFB',
                borderRadius: 8,
                border: '1px solid #EEF0F2',
            }}
        >
            <Typography variant="subtitle2" style={{ fontWeight: 700, marginBottom: 8 }}>
                Ejemplo — 10% de descuento
            </Typography>
            <Typography variant="body2" color="textSecondary" style={{ marginBottom: 16 }}>
                {example.intro}
            </Typography>
            {example.scenarios.map((scenario) => (
                <ExampleTable key={scenario.title} scenario={scenario} />
            ))}
        </Box>
    );
};

export const PromotionStrategyGlossary = () => (
    <Box
        mb={2}
        p={1.5}
        style={{
            background: '#F5F8FA',
            borderRadius: 8,
            borderLeft: '3px solid #9EE870',
        }}
    >
        {STRATEGY_GLOSSARY.map((item) => (
            <Typography key={item.term} variant="body2" style={{ marginBottom: 6 }}>
                <strong>{item.term}:</strong> {item.definition}
            </Typography>
        ))}
    </Box>
);

export default PromotionStrategyExample;
